/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';
import { loadSelectPickerItems } from '../../../../app/common/store/select-picker.actions';
import { queryParamsMap } from '../../../../app/common/components/forms/select-picker/select-picker-types.enum';

xplenty.directive('cloudStorageSourceEditor', [
  '$timeout',
  '$translate',
  '$rootScope',
  'selectPickerModal',
  'ngrxStoreService',

  function ($timeout, $translate, $rootScope, selectPickerModal, ngrxStoreService) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./cloud-storage-source-editor.html'),

      replace: true,

      link(scope) {
        scope.beforeActionOptions = [
          {
            value: 'none',
            text: 'cloud-storage-source-editor.form.selects.before_action.options.process_all_files',
            translate: true,
          },
          {
            value: 'copy_manifest',
            text: 'cloud-storage-source-editor.form.selects.before_action.options.process_only',
            translate: true,
          },
          {
            value: 'copy',
            text: 'cloud-storage-source-editor.form.selects.before_action.options.copy_merge_and_process',
            translate: true,
          },
        ];

        scope.onCharEncodingChange = function (charEncoding) {
          scope.component.char_encoding = charEncoding;
        };

        scope.onBeforeActionChange = function (beforeAction) {
          scope.component.before_action = beforeAction;
        };

        scope.selectManifestConnection = function (connection) {
          scope.component.manifest_connection = connection;
        };

        scope.onUpdateConnection = ({ connectionType, type }) => {
          selectPickerModal.createNew(connectionType, type, 'connection-picker-cloud-storage-editor');

          const subscriber = $rootScope.$on(EVENTS.CONNECTION_UPDATED, () => {
            ngrxStoreService.dispatch(
              loadSelectPickerItems({
                id: 'connection-picker-cloud-storage-editor',
                itemType: type,
                params: { ...queryParamsMap[type], ...scope.connectionQuery },
              }),
            );
            subscriber();
          });
        };

        scope.$watch(
          'component',
          function (newComponent, oldComponent) {
            if (
              newComponent.record_delimiter === 'eof' &&
              oldComponent.record_delimiter === 'new_line' &&
              newComponent.record_type === 'delimited'
            ) {
              scope.component.record_type = 'json';
            }

            scope.hasJsonPath = newComponent.record_delimiter === 'eof' && newComponent.record_type === 'json';
          },
          true,
        );

        // WHATCH: connection
        scope.$watch(
          function () {
            return scope.component.connection;
          },
          function (connection) {
            // console.log(connection);
            if (connection && connection.type) {
              switch (connection.type) {
                case 'rackspace':
                case 'softlayer':
                case 'swift':
                  scope.hasContainer = true;
                  scope.hasBucket = false;
                  scope.hasPreProcess = false;
                  break;
                case 'sftp':
                case 'ftps':
                  scope.hasContainer = false;
                  scope.hasBucket = false;
                  scope.hasPreProcess = true;
                  break;
                case 'hdfs':
                  scope.hasContainer = false;
                  scope.hasBucket = false;
                  scope.hasPreProcess = false;
                  break;
                case 's3':
                case 'gs':
                  scope.hasContainer = false;
                  scope.hasBucket = true;
                  scope.hasPreProcess = true;
                  break;
                case 'azureblobstorage':
                  scope.hasContainer = true;
                  scope.hasBucket = false;
                  scope.hasPreProcess = true;
                  break;
                default:
                  scope.hasContainer = false;
                  scope.hasBucket = false;
                  scope.hasPreProcess = false;
                  break;
              }
            }
          },
          true,
        );
      },

      controller: [
        '$scope',
        'ComponentEditorListeners',
        function ($scope, ComponentEditorListeners) {
          $scope.hasBucket = false;
          $scope.hasContainer = false;
          $scope.hasPreProcess = false;
          $scope.hasJsonPath = false;
          $scope.isDelimited = false;
          $scope.connectionQuery = {
            type: 's3,gs,sftp,ftps,azureblobstorage',
          };

          $scope.charEncodings = [
            {
              value: 'utf-8',
              text: $translate.instant('cloud-storage-source-editor.form.selects.char_encoding.options.utf_8'),
            },
            {
              value: 'utf-16',
              text: $translate.instant('cloud-storage-source-editor.form.selects.char_encoding.options.utf_16'),
            },
            {
              value: 'shift-jis',
              text: $translate.instant('cloud-storage-source-editor.form.selects.char_encoding.options.shift_jis'),
            },
            {
              value: 'cp932',
              text: $translate.instant('cloud-storage-source-editor.form.selects.char_encoding.options.cp932'),
            },
          ];

          if ($scope.component.source_path_field_alias) {
            // schema importer selected fields variable
            $scope.selectedFields.unshift({
              name: 'file_path',
              alias: $scope.component.source_path_field_alias,
              data_type: 'string',
              disableTypeEdit: true,
            });
          }

          const onSaveSuccessCallback = function () {
            const pathField = _.find($scope._selectedFields, { name: 'file_path' });

            if (angular.isDefined(pathField)) {
              $scope.component.source_path_field_alias = pathField.alias;
              // when saving actual taken fields (for no apparent reason) are from _selectedFields
              _.remove($scope._selectedFields, { name: 'file_path' });
            } else {
              $scope.component.source_path_field_alias = '';
            }
          };

          ComponentEditorListeners.onSaveSuccess(onSaveSuccessCallback);

          $scope.$on('$destroy', function () {
            ComponentEditorListeners.clearOnSaveSuccessCb(onSaveSuccessCallback);
          });
        },
      ],
    };
  },
]);
